import React from "react";
import { Pressable, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import CCText from "@/Atoms/CCText";
import type { ClubEvent } from "@/Hooks/ClubsApi/types";

// Puzzle Storm event bar, pinned at the top of the Club Room (design lines 323–337).
export default function EventBar({
  event,
  isAdmin,
  onEnd,
}: {
  event: ClubEvent;
  isAdmin?: boolean;
  onEnd?: () => void;
}) {
  const pct = Math.min(100, event.pct);
  return (
    <LinearGradient
      colors={["#FFF6E3", "#FDE7C2"]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={{
        borderRadius: 12,
        borderWidth: 1,
        borderColor: "#F3D08A",
        padding: 13,
        marginHorizontal: 14,
        marginTop: 10,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
        <View style={{ flexDirection: "row", alignItems: "center", gap: 7 }}>
          <CCText style={{ fontSize: 16 }}>⚡</CCText>
          <CCText style={{ fontSize: 13.5, fontWeight: "700", color: "#8A5A12" }}>{event.title}</CCText>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
          <CCText style={{ fontSize: 11, fontWeight: "700", color: "#E17B21" }}>{pct}%</CCText>
          {isAdmin && onEnd ? (
            <Pressable testID="event-end" onPress={onEnd} hitSlop={6}>
              <CCText style={{ fontSize: 11, fontWeight: "600", color: "#B0762A" }}>End</CCText>
            </Pressable>
          ) : null}
        </View>
      </View>

      {/* Progress bar with 25% / 50% milestone ticks (design). */}
      <View
        style={{
          marginTop: 8,
          height: 8,
          backgroundColor: "#F5E3BE",
          borderRadius: 999,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <View
          style={{ width: `${pct}%`, height: "100%", backgroundColor: "#E17B21", borderRadius: 999 }}
        />
        <View style={{ position: "absolute", left: "25%", top: 0, bottom: 0, width: 1.5, backgroundColor: "rgba(138,90,18,0.3)" }} />
        <View style={{ position: "absolute", left: "50%", top: 0, bottom: 0, width: 1.5, backgroundColor: "rgba(138,90,18,0.3)" }} />
      </View>

      <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: 7 }}>
        <CCText style={{ fontSize: 11.5, color: "#8A5A12" }}>
          {event.progress.toLocaleString("en-IN")} / {event.goal.toLocaleString("en-IN")} puzzles
        </CCText>
        <CCText style={{ fontSize: 11.5, fontWeight: "600", color: "#1E7A3D" }}>
          Your +{event.my_contribution} ✓
        </CCText>
      </View>
    </LinearGradient>
  );
}
